var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row",class:_vm.$style.root},[_c('TrafficLocationsMap')],1)}
var staticRenderFns = []

export { render, staticRenderFns }